export default __webpack_public_path__ + "static/media/morvarid.a3260625.png";